export * from './IconLightning';
export { default as IconLightning } from './IconLightning';
